<template>
  <div>
    <div class="row align-items-center">
      <div class="col col-11">
        <div class="card-header border-0">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label page-title fw-bolder fs-3 mb-1"
              >Payments</span
            >
          </h3>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body py-10">
        <div class="tab-content">
          <!--begin::Tap pane-->
          <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
            <div class="row">
              <div class="row justify-content-between">
                <div class="col">
                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span class="required">Sales Report Date Range</span>
                    <i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                      title="Select the date range for the sales report"
                    ></i>
                  </label>
                </div>
                <div class="col text-end">
                  <button class="btn btn-secondary" @click="reset">
                    Reset Date Range
                  </button>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <v-date-picker v-model="dateRange" range></v-date-picker>
                </div>
              </div>
            </div>

            <div class="row">
              <button
                @click="exportReport"
                class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6"
              >
                <span v-if="!exporting">Export Sales Report</span>

                <v-progress-circular
                  width="2"
                  size="25"
                  v-if="exporting"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </button>
            </div>
          </div>
        </div>
        <ConfirmationModal
        :isLoadingConfirmation="loadingConfirmation"
        :isShowDialog="isShowConfirmationModal"
        :btnConfig="buttonConfiguration"
        :inputInfo="confirmationModalInfo"
        :inputColor="confirmationModalInfoColor"
      />
      <SnackbarNotifier
        :isShow="isShowSnackBar"
        :message="responseMessage"
        :snackType="snackbarType"
        :colour="snackBarColour"
        @eReset="resetSnackBar"
      />
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import mixins from "vue-typed-mixins";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import dayjs from "dayjs";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ManagePayments",
  components: {
    ConfirmationModal,
    SnackbarNotifier,
  },
  data() {
    return {
      dateRange: [dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
      exporting: false,
    };
  },
  computed: {
    dateRangeObject() {
      let startDate = "",
        endDate = "";
      try {
        if (!this.dateRange || this.dateRange.length < 2) {
          return { startDate, endDate };
        }

        startDate = this.dateRange[0];

        endDate = this.dateRange[1];

        if (dayjs(this.dateRange[0]).isAfter(dayjs(this.dateRange[1]))) {
          startDate = this.dateRange[1];

          endDate = this.dateRange[0];
        }
      } catch (e) {
        error(e);
      }
      return { startDate, endDate };
    },
  },
  methods: {
    async exportReport() {
      try {
        this.startConfirmationLoading();
        this.exporting = true;
        await ApiService.Instance.salesReport({
          startDate: this.dateRangeObject.startDate,
          endDate: this.dateRangeObject.endDate,
        });
        this.stopConfirmationLoading();
        this.exporting = false;
        this.showNotifier({
          message: "Successfully Exported The Report",
          snackbarType: "success",
        });
      } catch (err) {
        this.showNotifier({
          message: "Failed To Export The Report",
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        this.exporting = false;
        error(err);
      }
    },
    reset() {
      this.dateRange = [
        dayjs().format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD"),
      ];
      this.exporting = false;
    },
  },
});
</script>

<style lang="scss" scoped>
</style>